import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { site } from '@panel/commons/helpers';
import { useQuery } from '@panel/commons/hooks';
import BancoGeneralPanama from '@panel/commons/assets/logos/banco_general_panama.svg';
import BancoBanitsmoPanama from '@panel/commons/assets/logos/banistmo_panama.svg';
import {
  Title,
  WireTransferInfoContainer,
  WireTransferInfoBankContainer,
  WireTransferRow,
  WireTransferMessage,
  LogoBankPanama
} from '../../styles';
import { getOrderData, selectCurrentProduct, selectEcommerceUser } from '../../../../../ducks/step4Module2';
import { sendPaymentNotification } from '../../../../../utils';

function WireTransferInfo() {
  const currentProduct = useSelector(selectCurrentProduct);
  const { orderId, amount, taxes, totalAmount: total } = useSelector(getOrderData);
  const { firstName, lastName } = useSelector(selectEcommerceUser);
  const [postingId] = useQuery(useLocation(), ['postingId']);
  const { t } = useTranslation();

  useEffect(() => {
    if (!site.isPanama || !currentProduct.id) {
      window.location.href = `/panel/publicador/planes/seleccion${window.location.search}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function sendMail() {
      const mailData = {
        orderId,
        amount,
        taxes,
        total,
        postingId,
        postingType: currentProduct.fullTitle,
        userName: `${firstName} ${lastName}`
      };
      await sendPaymentNotification('TRANSFER', mailData);
    }
    if (orderId) {
      sendMail();
    }
  }, [amount, currentProduct.fullTitle, firstName, lastName, orderId, postingId, taxes, total]);

  return (
    <div>
      <Title wireTransfer>{t('publisher.step4.module2.payment.wireTransfer.title')}</Title>
      <WireTransferInfoContainer>
        <Title main>{t('publisher.step4.module2.payment.wireTransfer.online.title')}</Title>
        <Title subtitle>{t('publisher.step4.module2.payment.wireTransfer.subtitle')}</Title>
        <WireTransferInfoBankContainer>
          <LogoBankPanama general src={BancoGeneralPanama} />
          <WireTransferRow>
            <p>
              {t('publisher.step4.module2.payment.wireTransfer.accountType')}
              <span>{t('publisher.step4.module2.payment.wireTransfer.accountType.data')}</span>
            </p>
          </WireTransferRow>
          <WireTransferRow>
            <p>
              {t('publisher.step4.module2.payment.wireTransfer.beneficiary')}
              <span>{t('publisher.step4.module2.payment.wireTransfer.beneficiary.data')}</span>
            </p>
          </WireTransferRow>
          <WireTransferRow>
            <p>
              {t('publisher.step4.module2.payment.wireTransfer.accountNumber')}
              <span>{t('publisher.step4.module2.payment.wireTransfer.accountNumber.bancoGeneral.data')}</span>
            </p>
          </WireTransferRow>
          <WireTransferRow>
            <p>
              {t('publisher.step4.module2.payment.wireTransfer.swiftCode')}
              <span>{t('publisher.step4.module2.payment.wireTransfer.swiftCode.bancoGeneral.data')}</span>
            </p>
          </WireTransferRow>
        </WireTransferInfoBankContainer>
        <WireTransferInfoBankContainer>
          <LogoBankPanama src={BancoBanitsmoPanama} />
          <WireTransferRow>
            <p>
              {t('publisher.step4.module2.payment.wireTransfer.accountType')}
              <span>{t('publisher.step4.module2.payment.wireTransfer.accountType.data')}</span>
            </p>
          </WireTransferRow>
          <WireTransferRow>
            <p>
              {t('publisher.step4.module2.payment.wireTransfer.beneficiary')}
              <span>{t('publisher.step4.module2.payment.wireTransfer.beneficiary.data')}</span>
            </p>
          </WireTransferRow>
          <WireTransferRow>
            <p>
              {t('publisher.step4.module2.payment.wireTransfer.accountNumber')}
              <span>{t('publisher.step4.module2.payment.wireTransfer.accountNumber.banistmo.data')}</span>
            </p>
          </WireTransferRow>
          <WireTransferRow>
            <p>
              {t('publisher.step4.module2.payment.wireTransfer.swiftCode')}
              <span>{t('publisher.step4.module2.payment.wireTransfer.swiftCode.banistmo.data')}</span>
            </p>
          </WireTransferRow>
          <WireTransferMessage>
            <p>
              {t('publisher.step4.module2.payment.wireTransfer.message.online.part1')}
              <span>{t('publisher.step4.module2.payment.wireTransfer.message.online.email')}</span>
              {t('publisher.step4.module2.payment.wireTransfer.message.online.part2')}
              <span>{t('publisher.step4.module2.payment.wireTransfer.message.online.phone')}</span>
              {t('publisher.step4.module2.payment.wireTransfer.message.online.part3')}
            </p>
          </WireTransferMessage>
        </WireTransferInfoBankContainer>
      </WireTransferInfoContainer>
      <WireTransferInfoContainer>
        <Title main>{t('publisher.step4.module2.payment.wireTransfer.check.title')}</Title>
        <Title subtitle>{t('publisher.step4.module2.payment.wireTransfer.subtitle')}</Title>
        <WireTransferRow check>
          <p>
            {t('publisher.step4.module2.payment.wireTransfer.message.check.part1')}
            <span>{t('publisher.step4.module2.payment.wireTransfer.message.check.part2')}</span>
          </p>
        </WireTransferRow>
      </WireTransferInfoContainer>
    </div>
  );
}

export default WireTransferInfo;
